import React, { useEffect, useRef, useState } from 'react';
import styles from './BotResponse.module.scss';
import renderStepContent from './factory/RenderStepContent';
import { useFormikContext } from 'formik';
import BotLoader from '../bot-loader/BotLoader';
import moment from 'moment';
import { chatDateFormat } from 'helpers/chatDateFormat';
import ResponseReactions from './factory/components/reactions/ResponseReactions';

const RTL_CHAR_REGEX = /[\u0591-\u07FF\u08A0-\u08FF\uFB1D-\uFEFC]/g;
let activeAudio = null;

function detectDirFromText(input) {
  if (!input) return 'ltr';
  const stripped = String(input).replace(/<[^>]*>/g, '');
  const rtlCount = (stripped.match(RTL_CHAR_REGEX) || []).length;
  const ltrCount = (stripped.match(/[A-Za-z]/g) || []).length;
  return rtlCount > ltrCount ? 'rtl' : 'ltr';
}

function getStepText(step) {
  const v = step?.value;
  if (typeof v === 'string') return v;
  if (typeof v?.text === 'string') return v.text;
  if (typeof v?.message === 'string') return v.message;
  if (typeof step?.text === 'string') return step.text;
  if (typeof step?.title === 'string') return step.title;
  return '';
}
const BotResponse = ({
  chatData,
  sideBar_PrimaryColor,
  isWorkFlow,
  isRequesting,
  chatId,
  botId,
  hasSidebar,
  setGuestChat,
  setCapture,
  guestChat,
  setSuggestedQuestions,
  isExpanded,
  direction,
  restartForm,
  isConversation,
  onHasFormChange,
  triggerNewConversation,
  selectedBot,
}) => {
  const formik = useFormikContext();

  useEffect(() => {
    const hasForm = chatData?.content?.some(
      (step) =>
        step.type === 'Form' &&
        Array.isArray(step.value?.formDetails) &&
        step.value.formDetails.length > 0,
    );

    if (typeof onHasFormChange === 'function') {
      onHasFormChange(hasForm);
    }
  }, []);

  const firstText = getStepText(chatData?.content?.[0]);
  const blockDir = detectDirFromText(firstText);
  return (
    <div className={styles['request-container']}>
      {chatData?.content?.length > 0 && (
        <div className={styles['bot-respond']}>
          <div className={styles['respond']} dir={blockDir}>
            <div className={styles['bot']}>
              {selectedBot?.src ? (
                <img
                  className={styles['bot-image']}
                  src={selectedBot?.src}
                  alt=''
                />
              ) : (
                <div className={styles['bot-default']}>
                  <p>
                    {selectedBot?.botName
                      ?.split(' ')
                      .filter(Boolean)
                      .map((word) => word.charAt(0).toUpperCase())
                      .slice(
                        0,
                        selectedBot?.botName?.trim().split(/\s+/).length > 2
                          ? 3
                          : undefined,
                      )
                      .join('')}
                  </p>
                </div>
              )}
            </div>
            <div className={styles['request']}>
              <div className={styles['res-container']}>
                {chatData.isLoading ? (
                  <div
                    style={{ paddingLeft: hasSidebar ? '1rem' : '' }}
                    className={styles['bot-loader']}
                  >
                    <BotLoader />
                  </div>
                ) : (
                  chatData?.content?.map((step, index) => {
                    const stepText = getStepText(step);
                    const stepDir = detectDirFromText(stepText);
                    return (
                      <div
                        key={step.id || `step-${index}`}
                        style={{
                          maxWidth: step.type === 'Carousel' ? '800px' : '',
                        }}
                        dir={stepDir}
                      >
                        {chatData.workflowName ? (
                          <div className={styles['tag-wrapper']}>
                            <span className={styles['tag-title']}>
                              Intent:{' '}
                            </span>
                            <span className={styles['tag']}>
                              {chatData.workflowName}
                            </span>
                          </div>
                        ) : null}
                        {renderStepContent({
                          step,
                          sideBar_PrimaryColor,
                          isWorkFlow,
                          formik,
                          isRequesting,
                          chatId,
                          botId,
                          setGuestChat,
                          setCapture,
                          setSuggestedQuestions,
                          isExpanded,
                          direction,
                          restartForm,
                          guestChat,
                          isConversation,
                          triggerNewConversation,
                          parentIsStreaming: chatData?._isStreaming === true,
                        })}
                        {!chatData?.isLoading &&
                        // !disableConsole &&
                        index === chatData.content.length - 1 ? (
                          <div className={styles['chat-sub-actions']}>
                            <ResponseReactions
                              stepId={step.id}
                              responseId={chatData?.stepId}
                              botId={botId}
                              chatData={chatData}
                              setGuestChat={setGuestChat}
                              guestChat={guestChat}
                              // settings={settings?.data}
                              settings={{ readAloud: true }}
                              step={step}
                            />
                          </div>
                        ) : null}

                        {index === chatData.content.length - 1 && (
                          <div className={styles['actions-container']}>
                            <p className={styles['date']}>
                              <span dir='ltr'>
                                {chatDateFormat(step?.dateCreated)}
                              </span>
                            </p>
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BotResponse;
